module.exports = __webpack_public_path__ + "static/media/ermia.08d38159.png";